import styled, { css } from "styled-components";

export const FocusedWrapper = styled.div<{ fullScreen?: boolean }>`
  overflow: hidden;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ fullScreen, theme }) =>
    fullScreen &&
    css`
      position: fixed;
      width: 100%;
      background: ${theme.colors.neutral[100]};
      top: 0;
      left: 0;
    `}
`;
